import builder from '../builder';
import AsianInteriorEatingTable from '../../streamline-icons/bold/asian-interior-eating-table.svg';

export default builder(
  'IconAsianInteriorEatingTableBold',
  AsianInteriorEatingTable,
);
